<template>
	
	<div class="wizard-component checkboxes">

		<p class="subject">Subject headline here</p>

		<div class="checkbox-list">

			<label class="custom-checkbox" v-for="item in checkboxes">
				<input type="checkbox" id="item.id" v-bind:value="item.value">
				<span class="checkbox">
					<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
					  <path class="fill-checkmark" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
					</svg>
				</span>
				<p>{{ item.text }}</p>
			</label>

		</div>
	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			checkboxes: [
				{
					id: 'one',
					value: 'One',
					text: 'Something in checkbox'
				},
				{
					id: 'two',
					value: 'Two',
					text: 'Something else in checkbox'
				}
			]

		})

	}
</script>


<style></style>